var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"row"},[_c('SideBar',{staticClass:"col-md-6 col-lg-3"}),_c('AboutMe',{staticClass:"col-md-6 col-lg-9"})],1),_c('div',{staticClass:"row"},[_c('Journey',{staticClass:"col-sm-12"})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }